import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "sign-in-content" }
const _hoisted_2 = { class: "sign-in-container" }
const _hoisted_3 = { class: "back-button" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "auth-options" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicLayout = _resolveComponent("PublicLayout")!

  return (_openBlock(), _createBlock(_component_PublicLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args))),
              class: "subtle-button"
            }, " ← Back to Home ")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "logo-container" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Prec8",
                class: "sign-in-logo"
              })
            ], -1)),
            _cache[3] || (_cache[3] = _createElementVNode("h1", null, [
              _createTextVNode("Welcome Back to "),
              _createElementVNode("span", { class: "highlight" }, "Prec8")
            ], -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "subtitle" }, "Sign in to manage your team recognition", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                href: _ctx.signInToSlackUrl,
                class: "slack-button"
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 122.8 122.8",
                  class: "slack-icon"
                }, [
                  _createElementVNode("path", {
                    d: "M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z",
                    fill: "#e01e5a"
                  }),
                  _createElementVNode("path", {
                    d: "M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z",
                    fill: "#36c5f0"
                  }),
                  _createElementVNode("path", {
                    d: "M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z",
                    fill: "#2eb67d"
                  }),
                  _createElementVNode("path", {
                    d: "M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z",
                    fill: "#ecb22e"
                  })
                ], -1),
                _createTextVNode(" Continue with Slack ", -1)
              ]))], 8, _hoisted_6)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "info-text" }, [
              _createElementVNode("p", null, "Sign in securely using your Slack workspace credentials")
            ], -1))
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "decoration" }, [
            _createElementVNode("div", { class: "floating-card card-1" }, [
              _createElementVNode("span", { class: "emoji" }, "🌟"),
              _createElementVNode("p", null, "Welcome back!")
            ]),
            _createElementVNode("div", { class: "floating-card card-2" }, [
              _createElementVNode("span", { class: "emoji" }, "👋"),
              _createElementVNode("p", null, "Good to see you again")
            ])
          ], -1))
        ])
      ])
    ]),
    _: 1
  }))
}